// extracted by mini-css-extract-plugin
module.exports = {"imageContainer":"cj-z","summaryPar":"dj-z","ratingCategories":"ej-z","reviewerInfo":"fj-z","reviewTypes":"gj-z","expanded":"hj-z"};